<template>
    <v-form ref="addNewAnalysis" v-model="valid">
        <v-row>
            <v-col cols="12" class="text-center">
                <UploadButton ref="fileUpload" :allowedFileExtensions="allowedFileExtensions" @fileSelected="fileSelected" @fileInvalid="fileInvalid" :maxFileSizeMB="2" />
            </v-col>
            <v-col cols="12" class="text-center" v-if="fileError">
                <v-alert text type="error">{{fileError}}</v-alert>
            </v-col>
            <v-col cols="12" class="text-center">
                <v-btn color="success" @click="addImage" :disabled="!validComplete || saving" :loading="saving">Add Image</v-btn>
            </v-col>
            <v-col cols="12" class="text-center" v-if="saveError">
                <v-alert text type="error">{{saveError}}</v-alert>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import UploadButton from '@/components/common/UploadButton.vue';
import fileService from '../../services/fileService';

export default {
    components: {
        UploadButton
    },
    props: {   
        email: {
            type: String,
            default: -1
        },
    },
    data() {
        return {
            loadingError: "",
            images: {
            },
            valid: false,
            allowedFileExtensions: '.JPEG, .PNG, .JPG',
            fileError: "",
            pendingFile: null,
            saveError: "",
            saving: false
        };
    },
    computed: {
        validComplete() {
            return this.pendingFile != null;
        }
    },
    methods:{
        createBlankAnalysis() {
            this.images = {
                description:"",
                OtherComments: "",
            };

            this.pendingFile = null;

            if (this.$refs.fileUpload) {
                this.$refs.fileUpload.reset();
            }
        },
        async addImage() {
            this.saving = true;
            this.saveError = "";

            try {
                // Add the file
                if (this.pendingFile != null) {
                    var image = {
                        Email: this.email,
                        FileName: this.pendingFile.FileName,
                    };

                    await fileService.uploadSignatureImage(image, this.pendingFile.FileName, "signatureImage", this.pendingFile.ContentType, this.pendingFile.FileData)
                }

                this.$emit("created");

                // Clear everything
                this.createBlankAnalysis();
            } catch (e) {
                this.saveError = e.message;
            }
            
            this.saving = false;
            this.$emit("closeUploadDialog");
        },
        fileSelected(file) {
            this.fileError = '';
            this.pendingFile = file;
        },
        fileInvalid(errorMessage) {
            this.fileError = errorMessage;
            this.pendingFile = null;
        },
    },
    async created() {

        this.createBlankAnalysis();

    }
}
</script>

<style scoped>
    td.width-25percent {
        width: 25%;
    }
    td.width-15percent {
        width: 15%;
    }
    td.width-5percent {
        width: 5%;
    }
</style>